import React from "react";
import AppsIcon from "@mui/icons-material/Apps";
import PropTypes from "prop-types";

export const AnatomyIcon = (props) => {
  return (
    <AppsIcon
      sx={{
        color: props.active ? "secondary.main" : "primary.main",
        fontSize: "2rem",
      }}
    />
  );
};

AnatomyIcon.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
};
